// Make a copy of this file and save it as config.js (in the src directory).

// Set this to the base URL of your sample server, such as 'https://your-app-name.herokuapp.com'.
// Do not include the trailing slash. See the README for more information:

const SAMPLE_SERVER_BASE_URL = 'http://YOUR-SERVER-URL';

// OR, if you have not set up a web server that runs the learning-opentok-php code,
// set these values to OpenTok API key, a valid session ID, and a token for the session.
// For test purposes, you can obtain these from https://tokbox.com/account.

const API_KEY = process.env.REACT_APP_API_KEY || ''
const SESSION_ID = process.env.REACT_APP_SESSION_ID  || ''
const TOKEN = process.env.REACT_APP_TOKEN  || ''

export {
  SAMPLE_SERVER_BASE_URL,
  API_KEY,
  SESSION_ID,
  TOKEN,
};



// WEBPACK FOOTER //
// ./src/config.js